import "../../../../src/content/my-peace-with-god/mpwg.scss";
import * as React from 'react';
export default {
  React
};